<template>
  <div>
    <div>
      <el-form ref="formFilter" :model="formFilter" label-width="75px" label-position="right" @submit.native.prevent>
        <filter-box :item-width="300">
          <el-form-item label="申请日期">
            <date-range class="filter-item" v-model="formFilter.createDate" :clearable="true" :allowTypes="['day']"
              align="left" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-button slot="operator" type="default" @click="onReset()" :plain="true">重置</el-button>
          <el-button slot="operator" type="primary" @click="onSearch()" :plain="true">查询</el-button>
        </filter-box>
      </el-form>
    </div>
    <div id="myChart" :style="{ width: '100%', height: '600px' }"></div>
    <div>
      <el-table header-cell-class-name="table-header-gray" :data="tableHead">
        <el-table-column label="月份" prop="name">
        </el-table-column>
        <el-table-column label="变更总数" prop="barData"> </el-table-column>
        <el-table-column label="完成数" prop="lineData"> </el-table-column>
        <el-table-column label="完成率 %" prop="lineRate"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { findTreeNodePath } from "@/utils";
import { uploadMixin } from "@/core/mixins";
import {
  changeReportController
} from "@/api";
export default {
  props: {
    rowData: Object,
  },
  mixins: [uploadMixin],
  data() {
    return {
      formFilter: {
        createDate: [],
      },
      tableHead: [],
    };
  },
  methods: {
    onSearch() {
      var date = this.formFilter.createDate;
      var params = {};
      if (date.length > 0) {
        params['startTime'] = date[0];
        params['endTime'] = date[1];
      }
      this.loadData(params);
    },
    initData(data) {
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      const xAxis = [];
      const barData = [];
      const plannedCount = [];
      const actualCount = [];
      data.forEach(item => {
        xAxis.push(item.month);
        plannedCount.push(item.flowCount);
        actualCount.push(item.finishCount);
        if (item.flowCount == 0) {
          barData.push('0.0');
        } else {
          barData.push((Math.round(item.finishCount / item.flowCount * 1000) / 10).toFixed(1));
        }
      });


      var head = [];
      for (var i = 0; i < xAxis.length; i++) {
        head.push({ "name": xAxis[i], "barData": plannedCount[i],"lineData": actualCount[i],"lineRate": barData[i] });
      }

      this.tableHead = head;

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data: ['变更总数', '完成数', '完成率']
        },
        xAxis: [
          {
            type: 'category',
            data: xAxis,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '变更总数',
            min: 0,
            scale: true,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '完成率',
            min: 0,
            scale: true,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: [
          {
            color: ['#CCCCCC'],
            name: '变更总数',
            type: 'bar',
            data: plannedCount,
            barGap: '-100%', // Make series be overlap
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: { //数值样式
                    color: '#CCCCCC',
                    fontSize: 14
                  }
                }
              }
            }
          },
          {
            color: ['#3398DB'],
            name: '完成数',
            type: 'bar',
            data: actualCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: { //数值样式
                    color: '#3398DB',
                    fontSize: 14
                  }
                }
              }
            }
          },
          {
            name: '完成率',
            type: 'line',
            yAxisIndex: 1,
            data: barData,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: { //数值样式
                    color: '#D0021B',
                    fontSize: 12
                  },
                  formatter: '{c}% '
                }
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    },
    loadData(params) {
      var _that = this;
      changeReportController.finishRate(this, params)
        .then((res) => {
          _that.initData(res.data);
        })
        .catch((e) => {

        });
    },
    onReset() {
      this.formFilter.createDate = [];
      this.onSearch();
    },
  },
  computed: {
    isEdit() {
      return this.formData.userId != null;
    },
  },
  mounted() {
    this.loadData({});
  }
};
</script>

<style lang="scss" scoped></style>
